import { render } from "./TableQuestion.vue?vue&type=template&id=2c13b0a0&scoped=true"
import script from "./TableQuestion.vue?vue&type=script&lang=js"
export * from "./TableQuestion.vue?vue&type=script&lang=js"

import "./TableQuestion.vue?vue&type=style&index=0&id=2c13b0a0&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c13b0a0"]])

export default __exports__